import { computed, observable, action, makeObservable } from 'mobx';

import Entities from 'STORE';

class User {
  @observable userId = null;

  constructor(commonStore, { userId }) {
    makeObservable(this);
    this.commonStore = commonStore;
    this.userId = userId;
  }

  @computed
  get user() {
    return Entities.usersStore.getUserById(this.userId);
  }

  get avatarTitle() {
    return this.user.avatarTitle || this.user.name;
  }

  get avatarUrl() {
    return this.user.avatarUrl || this.user.avatar || this.user.image;
  }

  get avatarBackgroundColorIndex() {
    return this.user.avatarColorIndex;
  }

  get title() {
    return this.user.displayName;
  }

  get subtitle() {
    return this.user.displayPhoneOrNickname;
  }

  get isMe() {
    return this.user.isMe;
  }

  @action
  onDelete = () => {
    this.commonStore.deleteMyReactions();
  };
}

export default User;
